import { formatMoney } from "@Utils/Functions";
import moment from "moment";

export const firstLetterToUppercase = word => {
	const editedWord = word?.charAt(0)?.toUpperCase() + word?.slice(1);
	return editedWord;
};

export const getOptionsSelectedText = (filterTypeObj, filterType) => {
	if (Array.isArray(filterType)) {
   		return filterTypeObj.filter((filter) => filterType.includes(filter.value)).map(v => v.text).join(', ')
	} else if (typeof filterType === "number") {
		return filterTypeObj.filter((filter) => filter.value === filterType)[0].text
	} else return ""
}

export const labelForBedroomsAndBathrooms = (filtersTags, showRoomsText = false) => {
	const dormsText = showRoomsText ? "ambs" : "dorms"
	const capitalizedDormsText = dormsText.charAt(0).toUpperCase() + dormsText.slice(1)

	if(!filtersTags?.bedrooms?.length && !filtersTags?.rooms?.length && !filtersTags.bathrooms?.length) {
		return capitalizedDormsText + ' y baños'
	}

	let result = '';
	
	if(!!filtersTags?.bedrooms?.length) {
		if( filtersTags?.bedrooms.length === 1) {
			let text = '';
			
			if (filtersTags?.bedrooms[0].value === 0) text = "Mono"
			else text = filtersTags?.bedrooms[0].value;
			
			text += ' ' + capitalizedDormsText + ' '
			result = text;
		} else {
			result = filtersTags?.bedrooms.reduce((acc, curr)=> {
				let text = '';
			
				if (curr.value === 0) text = "Mono"
				else text = curr.value
				
				return acc += text + ', '
			}, '').replace(/, $/, '');

			result = result.replace(/, (\d+)$/, ' y $1') + ' ' + capitalizedDormsText + ' ';
		}

		if(!filtersTags?.bedroomsExactMode?.value) {
			result = result.replace(/(\d+|Mono)/g, '$1+')
		}
	} else if (!!filtersTags?.rooms?.length) {
		if( filtersTags?.rooms.length === 1) {
			result = filtersTags?.rooms[0].text
		} else {
			result = filtersTags?.rooms.reduce((acc, curr)=> acc += curr.value + ', ', '').replace(/, $/, '');
			result = result.replace(/, (\d+)$/, ' y $1') + ' ' + ('ambientes');
		}

		if(!filtersTags?.bedroomsExactMode?.value) {
			result = result.replace(/(\d+)/g, '$1+')
		}
	} else {
		result = capitalizedDormsText
	}

	if(!!filtersTags?.bathrooms?.length) {
		if(result !== '') {
			result += ' / ';
		}

		let result_baths = '';
		if( filtersTags?.bathrooms.length === 1) {
			result_baths = filtersTags?.bathrooms[0].value + ' ' + ('baños');
		} else {
			result_baths = filtersTags?.bathrooms.reduce((acc, curr)=> acc += curr.value + ', ', '').replace(/, $/, '');
			result_baths = result_baths.replace(/, (\d+)$/, ' y $1') + ' ' + ('baños');
		}
		if(!filtersTags?.bathroomsExactMode?.value) {
			result_baths = result_baths.replace(/(\d+)/g, '$1+')
		}
		result = result + result_baths
	} else {
		result += "/ Baños"
	}

	return result === '' ? capitalizedDormsText + ' y baños' : result;
}

export const getLabelSeasonsAndDates = (filtersTags) => {
	const dateFromFormatted = filtersTags?.dateFrom ? moment(filtersTags?.dateFrom?.text, "YYYY/MM/DD").format("DD/MM/YYYY") : "";
	const dateToFormatted = filtersTags?.dateTo ? moment(filtersTags?.dateTo?.text, "YYYY/MM/DD").format("DD/MM/YYYY") : "";

	if (filtersTags?.dateFrom && filtersTags?.dateTo) return `${dateFromFormatted} al ${dateToFormatted}`
	if (filtersTags?.dateFrom && !filtersTags?.dateTo) return `Desde ${dateFromFormatted}`
	if (!filtersTags?.dateFrom && filtersTags?.dateTo) return `Hasta ${dateToFormatted}`
	if (filtersTags?.season) return filtersTags?.season?.text

	return "Fechas"
}

export const getLabelPriceRange = (minPrice, maxPrice, currency) => {
	const formattedMin = formatMoney(minPrice);
	const formattedMax = formatMoney(maxPrice);
	let text = '';

	if (formattedMin && formattedMax) {
		text = `${currency} ${formattedMin} - ${currency} ${formattedMax}`
	} else if (formattedMin) {
		text = `Desde ${currency} ${formattedMin}`
	} else if (formattedMax) {
		text = `Hasta ${currency} ${formattedMax}`
	} else {
		text = 'Precio'
	}

	return text;
}

export const validateRange = (min:(string | number), max:(string | number), message:string) => {
    if (Number(min) && Number(max) && Number(min) > 0 && Number(max) > 0) {
        return Number(min) > Number(max)
            ? message
            : '';
    }
    return '';
};

export const formatPhone = ({ phone, countryCode = "UY" }: {
	phone: string; 
	countryCode?: string;
  }): string => {
	if (countryCode !== "UY") {
		return phone;
	}
	
	const cleanPhone = phone.replace(/\D/g, "");
	const hasCountryCode = cleanPhone.startsWith("598");
	let localPhone = hasCountryCode ? cleanPhone.slice(3) : cleanPhone;
	if (hasCountryCode) localPhone = localPhone.startsWith("0") ? localPhone : `0${localPhone}`;

	if (localPhone.length < 7 || localPhone.length > 9) {
		return phone;
	}

	if (
		(localPhone.length === 8 && localPhone.startsWith("9")) ||
		(localPhone.length === 9 && localPhone.startsWith("0"))
	) {
		return `${localPhone.slice(0, 3)} ${localPhone.slice(3, 6)} ${localPhone.slice(6)}`;
	}

	if (localPhone.length === 8 && localPhone.startsWith("2")) {
		return `${localPhone.slice(0, 4)} ${localPhone.slice(4, 6)} ${localPhone.slice(6)}`;
	}

	if (localPhone.length === 7) {
		return `${localPhone.slice(0, 3)} ${localPhone.slice(3, 5)} ${localPhone.slice(5)}`;
	}

	if (hasCountryCode && localPhone.length === 9 && localPhone.startsWith("9")) {
		return `+598 ${localPhone.slice(0, 2)} ${localPhone.slice(2, 5)} ${localPhone.slice(5)}`;
	}

	if (hasCountryCode && localPhone.length === 8 && localPhone.startsWith("2")) {
		return `+598 ${localPhone.slice(0, 4)} ${localPhone.slice(4, 6)} ${localPhone.slice(6)}`;
	}
	
	return phone;
}